<template lang="pug">
  .kimple-folder-feed.card-container(:class="{ 'no-margin': !!noMargin }")
    .header.row.space-between.m-bottom-2.middle
      img(:src='folderIcon')
      .novelty-badge.m-left-2.row.middle(v-if='folder.novelty')
        simple-svg(:filepath='noveltyBadgeIcon' width='14px' height='14px')
        span.m-left-05.uppercase.text-xsmall.bold {{ $t('kimpleFolderContent.novelty') }}
      button(:title='$t("kimpleFolderCard.copyFolderInfo")' :disabled='isCopying' @click='copyFolder')
        simple-svg.blue-icon(:filepath='copyIcon' width='22px' height='22px')
    router-link(:to='{name: routes.kimpleFolderContent, params: { id: folder.id }}')
      h1.title-small.m-bottom-1.title {{ folder.title }}
    h2.text-normal {{ '#' + folder.hashtag }}
    .footer.row.middle
      span.row.middle.age-range.text-normal(
        v-for='ageRange in ageRanges'
        :style='getAgeRangeStyle(ageRange.mainColor)'
      ) {{ $t('folders.ageRange', {max: ageRange.maxAge, min: ageRange.minAge}) }}
</template>

<script>
import folderIcon from '@/assets/ic_folder.svg'
import copyIcon from '@/assets/ic_copy.svg'
import { routes } from '../router'
import { mapActions, mapState } from 'vuex'
import noveltyBadgeIcon from '@/assets/ic_novelty_badge.svg'
import amplitude from 'amplitude-js'
import { i18n } from '../main'

export default {
  props: {
    folder: { type: Object, required: true },
    noMargin: { type: Boolean, value: false }
  },
  data() {
    return {
      noveltyBadgeIcon,
      folderIcon,
      copyIcon,
      routes,
      isCopying: false
    }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    ageRanges() {
      return this.folder.ageRanges.slice(0, 2)
    }
  },
  methods: {
    ...mapActions([
      'copyKimpleFolder'
    ]),
    getAgeRangeStyle(color) {
      return {
        '--age-color': color
      }
    },
    async copyFolder() {
      this.isCopying = true
      const success = await this.copyKimpleFolder({ id: this.folder.id, locale: this.locale })
      if (success) {
        this.$notify({
          group: 'custom-toast',
          type: 'success',
          text: i18n.t('customToast.copyKimpleFolderSuccess'),
          duration: 6000
        })
        amplitude.getInstance().logEvent('Copy Kimple folder', { id: this.folder.id, name: this.folder.title })
      } else {
        this.$notify({
          group: 'custom-toast',
          type: 'error',
          text: i18n.t('customToast.copyKimpleFolderError'),
          duration: 6000
        })
      }
      this.isCopying = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/_colors.scss';

.card-container.no-margin {
  margin: 0;
}

.kimple-folder-feed{
  background-color: $white;
  justify-content: flex-start;
  border-radius: 8px;
  height: 220px;
  padding: 20px;
  .header{
    &>:first-child{
      width: 30px;
      opacity: 0.2;
    }
    button{
      &:disabled{
        opacity: 0.5;
        cursor: wait;
      }
      img{
        width: 18px;
      }
    }
  }
  .title{
    cursor: pointer;
  }
  .footer{
    margin-top: auto;
    &>:not(:last-child){
      margin-right: 16px;
    }
    .age-range::before{
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--age-color);
      display: block;
      margin-right: 10px;
    }
  }
  .novelty-badge {
    background-color: $yellow;
    border-radius: 16px;
    height: 22px;
    padding: 0 8px;
  }
}
</style>
